import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import type { Tone } from "./Dot";
export function StatusBadge(t0) {
  const $ = _c(3);
  const {
    tone,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== tone) {
    t1 = <span data-tone={tone} className="ui-status-badge">{children}</span>;
    $[0] = children;
    $[1] = tone;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}